import { h } from './index-d3a9c8bd.js';
import { c as clsx } from './clsx-1afe6a70.js';

const InternalRadioButton = ({ name, nesId, checked, disabled, border, label, helpText, onChange, onClick, tabIndex, value, loading, standalone, hiddenLabel, }) => (h("div", { class: "nes-radioButton" },
    h("input", { id: nesId, name: name, type: "radio", value: value, checked: checked, class: clsx('nes-radioButton__input', {
            'is-loading': loading,
        }), disabled: loading || disabled, onChange: onChange, onClick: onClick, tabIndex: tabIndex ? tabIndex : undefined }),
    h("div", { class: "nes-radioButton__text" },
        h("label", { htmlFor: nesId, class: clsx('nes-radioButton__label', {
                'nes-radioButton__label--border': border,
                'nes-radioButton__label--standalone': standalone,
            }), tabIndex: -1 },
            h("span", { class: clsx({
                    'nes-sr-only': hiddenLabel,
                }) }, label),
            helpText && h("nes-help-text", null, helpText)))));

export { InternalRadioButton as I };
